import { render, staticRenderFns } from "./App.vue?vue&type=template&id=f58567c8"
var script = {}
import style0 from "./App.vue?vue&type=style&index=0&id=f58567c8&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports